import { Project, Post } from '../types';

export const PROJECTS: Project[] = [
  {
    id: 1,
    slug: 'modulosm',
    title: 'modularOSM',
    category: 'brand design',
    year: 'feb-mar 2026',
    description:
      'the new-gen of modular data centre engineering. building a brand from the ground up. created for the UW/UX origins case competition.',
    tags: ['brand strategy', 'web design', 'case study'],
    gradient: 'linear-gradient(135deg, #e8f4fd 0%, #d4e8f7 40%, #c8dff5 100%)',
    accent: '#4a6fd4',
    emoji: '✦',
    img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=900&q=80',
    video: '/media/MOSM-vid.mp4',
  },
  {
    id: 2,
    slug: 'wingmate',
    title: 'wingmate',
    category: 'ui/ux design',
    year: 'jan-mar 2026',
    description: 'the dating app for fresh into the world people.',
    tags: ['ui/ux', 'app design', 'concept'],
    gradient: 'linear-gradient(135deg, #fef3e8 0%, #fde8d4 40%, #fad4c0 100%)',
    accent: '#e07a3d',
    emoji: '❋',
    img: '/media/wingmate-thumbnail.svg',
  },
  {
    id: 3,
    slug: 'hollow',
    title: 'perfect productivity app',
    category: 'Film',
    year: 'jan 2026',
    description:
      'user research is easy, when the only user is myself ·˚ ༘',
    tags: ['app design', 'ui/ux'],
    gradient:
      'linear-gradient(135deg, #f8f6f6 0%, #e3ded8 42%, #c9bfb8 72%, #bc8c82 100%)',
    accent: '#8f6a62',
    emoji: '𖦹',
    img: '/media/ppa.svg',
  },
];

export const POSTS: Post[] = [
  { date: 'feb 2026 -present', title: 'google ux certificate', time: 'in progress ★★☆' },
  { date: 'june 2026 -present', title: 'graphic designer', time: 'TLN Media Group' },
  { date: 'june-dec 2025', title: 'website & graphic designer', time: 'Let\'s Get Moving Corp.' },
  { date: 'march 2025 -present', title: 'qux co-founder & co-chair', time: 'queen\'s ux club' },
  { date: 'june 2025 -present', title: 'qwic graphic designer', time: 'queen\'s women in computing' },
];

/** About tab only — separate from `POSTS` (work tab experience ✦); edit freely */
export const ABOUT_EXPERIENCE_SECTION_TITLE = 'contact ✍︎';
export const ABOUT_EXPERIENCE_POSTS: Post[] = [
  {
    date: 'email',
    title: 'zhuu.amanda@gmail.com',
    time: '✉',
    href: 'mailto:zhuu.amanda@gmail.com',
  },
  {
    date: 'linkedin',
    title: 'let\'s connect!',
    time: '⛾',
    href: 'https://www.linkedin.com/in/amanda-zhu-b01422242/',
  },
  {
    date: 'instagram',
    title: '@a_zoo_studio',
    time: '✌︎㋡',
    href: 'https://www.instagram.com/a_zoo_studio/',
  },


];

/** fun-work tab: list below sticker board (same layout as experience ✦); edit title & rows */
export const FUN_WORK_SECTION_TITLE = 'the sticker board ✦';
export const FUN_WORK_ROWS: Post[] = [
  { date: '𓆝 𓆟 𓆞', title: 'all stickers', time: 'drag them around!' },
  {
    date: 'branding',
    title: 'queen\'s ux club',
    time: '@queens.ux',
    href: 'https://www.instagram.com/queens.ux/',
  },
  {
    date: 'design',
    title: 'queen\'s women in computing',
    time: '@queenswic',
    href: 'https://www.instagram.com/queenswic/',
  },
  {
    date: 'ideate at',
    title: 'id8',
    time: '@id8id8id8',
    href: 'https://www.instagram.com/id8id8id8/',
  },
  { date: 'collab', title: 'collaboration stickers', time: '—----' },
  {
    date: 'fun',
    title: 'personal projects',
    time: '@a_zoo_studio',
    href: 'https://www.instagram.com/a_zoo_studio/',
  },
];

export const NAV_TABS = ['work', 'about', 'experience'] as const;
export const CONTENT_TABS: Array<{ id: string; label: string }> = [
  { id: 'work', label: 'work' },
  { id: 'art', label: 'fun-work' },
  { id: 'about', label: 'about' },
];
/** 4×4 about page gallery (same assets as amandazhu.co/about), row-major order */
export const ABOUT_GALLERY_IMAGES: string[] = Array.from({ length: 16 }, (_, i) => {
  const n = String(i + 1).padStart(2, '0');
  return `/about-gallery/aboutme-${n}.png`;
});

export const FOOTER_LINKS = [
  { label: 'email', href: 'mailto:zhuu.amanda@gmail.com', external: false },
  {
    label: 'linkedin',
    href: 'https://www.linkedin.com/in/amanda-zhu-b01422242/',
    external: true,
  },
  {
    label: 'instagram',
    href: 'https://www.instagram.com/a_zoo_studio/',
    external: true,
  },
] as const;
